// change to LogsPage if making another css file
import './LogsPage.css';
import Logs from './DataComponent.js';
import React from 'react';
import Button from 'react-bootstrap/esm/Button';
import Table from 'react-bootstrap/Table';
import { auth } from './firebase.js'


const Home = (props) => {
  return (
    <div className="home">
      <div>{props.user != null
                ? <>
                    <img src={props.user.photoURL} alt="" />
                    Hello, {props.user.displayName}!
                  </>
                : <div/>
            }</div>
    </div>
  )
}

function LogsTable() {
  return(
    <Logs/>
  );
}

function LogsPage(props) {
  return (
    <div>
      <div className="logs-title"></div>
      <div className='center-table'>
        <Home user={props.user}/>
        <LogsTable/>
      </div>
      <h1/>
      <h1 />
    </div>
  );
}

export default LogsPage;
